export const screenIds = [
  'landing',
  'guest-help',
  'privacy-policy',
  'public-offer',
  'service-rules',
  'social-links',
  'login',
  'forgot-password',
  'forgot-password-sent',
  'reset-password',
  'reset-password-success',
  'email-confirm',
  'registration-role',
  'new-request-step-1',
  'new-request-step-2',
  'new-request-step-3',
  'new-request-step-4',
  'new-request-step-5',
  'new-request-step-6',
  'new-request-step-7',
  'new-request-step-8',
  'new-request-step-9',
  'new-request-step-9-role',
  'new-request-step-9-name',
  'new-request-step-9-name-company',
  'new-request-step-9-sent',
  'new-request-step-9-password',
  'new-request-step-10',
  'customer-rega-email',
  'customer-rega-type',
  'customer-rega-contact',
  'customer-rega-contact-company',
  'customer-rega-sent',
  'customer-rega-password',
  'customer-rega-success',
  'my-requests',
  'request-detail',
  'payment',
  'active-transport',
  'chat-list',
  'chat',
  'review',
  'dispute',
  'notifications',
  'settings',
  'profile-internal',
  'profile-external',
  'platform-feedback',
  'customer-help',
  'carrier-rega-email',
  'carrier-rega-type',
  'carrier-rega-contact',
  'carrier-rega-contact-company',
  'carrier-rega-sent',
  'carrier-rega-password',
  'carrier-verify',
  'carrier-verify-pending',
  'carrier-dashboard',
  'carrier-search',
  'carrier-request-detail',
  'carrier-offer',
  'carrier-my-offers',
  'carrier-chat-list',
  'carrier-chat',
  'carrier-active-transport',
  'carrier-completed',
  'carrier-earnings',
  'carrier-review',
  'carrier-profile-internal',
  'carrier-profile-external',
  'carrier-notifications',
  'carrier-dispute',
  'carrier-help',
  'carrier-documents',
  'carrier-settings',
] as const;

export type ScreenId = (typeof screenIds)[number];

const screenIdSet = new Set<string>(screenIds);

export function normalizeScreenId(hash: string): ScreenId {
  const value = hash.replace(/^#\/?/, '').split('?')[0];
  return screenIdSet.has(value) ? (value as ScreenId) : 'landing';
}
